import { z } from 'zod';

export const formSchema = z.object({
  carrier_id: z.string().optional(),
  carrier_ids: z.array(z.string()).optional(),
  document: z.string({
    required_error: 'Documento é obrigatório',
    invalid_type_error: 'Documento deve ser uma string',
  }),
  name: z.string({
    required_error: 'Nome é obrigatório',
    invalid_type_error: 'Nome deve ser uma string',
  }),
  birth_date: z
    .date({
      required_error: 'Data de nascimento é obrigatória',
      invalid_type_error: 'Data de nascimento deve ser uma data',
    })
    .refine(
      (date) => {
        const today = new Date();
        const age = today.getFullYear() - date.getFullYear();
        const isBirthdayPassed =
          today.getMonth() > date.getMonth() ||
          (today.getMonth() === date.getMonth() &&
            today.getDate() >= date.getDate());
        return age > 18 || (age === 18 && isBirthdayPassed);
      },
      { message: 'É necessário ter no mínimo 18 anos' }
    ),
  phone_number: z
    .string({
      invalid_type_error: 'Telefone deve ser uma string',
    })
    .nullable()
    .optional(),
  //   email: z.string().email("E-mail inválido").nullable().optional(),
  address_street: z.string().nullable().optional(),
  address_number: z.string().nullable().optional(),
  address_neighborhood: z.string().nullable().optional(),
  address_city: z.string().nullable().optional(),
  address_state: z.string().nullable().optional(),
  address_zipcode: z.string().nullable().optional(),
  address_id_city_ibge: z.string().nullable().optional(),
});
